var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_9ca1ebc695b5f509e80555d259dbb4b7",
    "data-name": "9ca1ebc695b5f509e80555d259dbb4b7",
    d: "M14.575,13l7.088-7.088a1.114,1.114,0,0,0-1.575-1.575L13,11.425,5.912,4.338A1.114,1.114,0,0,0,4.337,5.913L11.425,13,4.338,20.087A1.021,1.021,0,0,0,4,20.875,1.063,1.063,0,0,0,5.125,22a1.021,1.021,0,0,0,.787-.337L13,14.575l7.087,7.087a1.088,1.088,0,0,0,1.575,0,1.087,1.087,0,0,0,0-1.575Z",
    transform: "translate(-4 -4)",
    fill: "#ff4975"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b45e8235a6cec61fc8934ca026e15c52.svg";
export { ForwardRef as ReactComponent };